import { Component } from "@angular/core";

@Component({
	selector: "caass-ExpressIDCardPrinting",
	templateUrl: "./ExpressIDCardPrinting.component.html",
})
export class ExpressIDCardPrintingComponent {}
